import { useBrand } from "@/contexts/BrandContext";
import { exitBrandPreview } from "@/lib/brand/resolveSubdomain";

export default function BrandPreviewBar() {
  const { isPreview, brand } = useBrand();
  if (!isPreview) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-full bg-foreground text-background px-4 py-2 text-sm shadow-lg">
      <span>Previewing: {brand?.config.company_name || brand?.subdomain || "brand not found"}</span>
      <button onClick={exitBrandPreview} className="underline font-medium">Exit</button>
    </div>
  );
}
